/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect } from "react";
import {
  I2cInput, 
} from "@webcomponents/i2cwebcomponents/dist/react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import "../Prepaid.scss"; 
const ACH = ({
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => { 
  const optionalString = Yup.string().optional();

  const validationSchema = Yup.object({
    ov_ach_odfi: optionalString, 
    ov_ach_bank: optionalString,
    ov_ach_account: optionalString,
    ov_ach_routing: optionalString,
  });

  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "all",
    defaultValues: { 
      ov_ach_odfi: "",
      ov_ach_bank: "",
      ov_ach_account: "",
      ov_ach_routing: "",
    },
  });

  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;

  const fields = [ 
    "ov_ach_odfi",
    "ov_ach_bank",
    "ov_ach_account",
    "ov_ach_routing",
  ];
  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      fields.forEach((field) => {
        methods.setValue(field, formDataJson[4]["4_3"][field] ?? "");
      });
      methods.trigger();
    }
  }, [isFetching]);

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);

  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      4: {
        ...addFormData["4"],
        "4_3": { ...values },
      },
    });
  };

  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("4_3", true);
    else setFormValidStates("4_3", false);
  }, [Object.keys(errors).length]);

  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-sm">
              <div i2c-grid="6@md 4@lg">
                <div className="single-field-wrapper">
                  <Controller
                    name="ov_ach_odfi"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        className="single-input-field"
                        
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        size="large"
                        label="ODFI institute"
                        placeholder="Enter ODFI institute"
                        name={"ov_ach_odfi"}
                      />
                    )}
                  />
                  {/* <ErrorMessage
                    show={
                      errors.ov_ach_odfi &&
                      methods.formState.touchedFields.ov_ach_odfi
                        ? true
                        : false
                    }
                    message={errors.ov_ach_odfi?.message ?? "Invalid input"}
                  /> */}
                </div>
              </div>
              <div i2c-grid="6@md 4@lg">
                <div className="single-field-wrapper">
                  <Controller
                    name="ov_ach_bank"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        className="single-input-field"
                     
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        size="large"
                        label="Settlement Bank"
                        placeholder="Enter Settlement Bank"
                        name={"ov_ach_bank"}
                      />
                    )}
                  />
                  {/* <ErrorMessage
                    show={
                      errors.ov_ach_bank &&
                      methods.formState.touchedFields.ov_ach_bank
                        ? true
                        : false
                    }
                    message={errors.ov_ach_bank?.message ?? "Invalid input"}
                  /> */}
                </div>
              </div>
              <div i2c-grid="6@md 4@lg">
                <div className="single-field-wrapper">
                  <Controller
                    name="ov_ach_account"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        className="single-input-field"
                       
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        size="large"
                        label="Settlement Account"
                        placeholder="Enter Settlement Account"
                        name={"ov_ach_account"}
                      />
                    )}
                  />
                  {/* <ErrorMessage
                    show={
                      errors.ov_ach_account &&
                      methods.formState.touchedFields.ov_ach_account
                        ? true
                        : false
                    }
                    message={errors.ov_ach_account?.message ?? "Invalid input"}
                  /> */}
                </div>
              </div>
              <div i2c-grid="6@md 4@lg">
                <div className="single-field-wrapper">
                  <Controller
                    name="ov_ach_routing"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        className="single-input-field" 
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        size="large"
                        label="Settlement Routing Number"
                        placeholder="Enter Settlement Routing Number"
                        name={"ov_ach_routing"}
                      />
                    )}
                  />
                  {/* <ErrorMessage
                    show={
                      errors.ov_ach_routing &&
                      methods.formState.touchedFields.ov_ach_routing
                        ? true
                        : false
                    }
                    message={errors.ov_ach_routing?.message ?? "Invalid input"}
                  /> */}
                </div>
              </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default ACH;
